import React, { useEffect, useState } from 'react'
import './LatestRequest.css'
import Navbar from '../Navbar/Navbar'
import LatestRequestsC from '../../MyComponents/LatestRequest/LatestRequest'
import SearchAndFilterBar from '../../MyComponents/SearchAndFilterBar/SearchAndFilterBar';
import Footer from '../../MyComponents/Footer/Footer';
import { Bars } from 'react-loader-spinner';
import Loader from '../../MyComponents/Loader/Loader';
import toastService from '../../../services/toastService';
import { postData } from '../../../services/apiServices';
import { useNavigate } from 'react-router-dom';  


function LatestRequest() {
    const [isLoading, setIsLoading] = useState(false);
    const [LeastestRequest, setLatestRequest] = useState([])
    const navigate = useNavigate()
    useEffect(() => {
        getLatestRequests()
    }, [])

    const handleCardClick = (data) => {
        navigate('/request-detail', { state: { data } });

        console.log(data, ">>>A>D>AD>>A>DA>>A>>A>")
    };

    const getLatestRequests = async () => {
        setIsLoading(true)
        const data = {
            verification_token: "123456",
            table: "request_offer"
        }

        try {
            const result = await postData("/get", data)
            console.log("The data in the latest Request getting000000", result)
            setIsLoading(false)
            if (result?.message === "success") {
                setLatestRequest(result?.data.reverse())
            } else {
                toastService.showError("Something went wrong")
             }
        } catch (error) {
            setIsLoading(false)
            console.log(error, "error in the latest requst")
        }
    }
    return (

        <>
            <Loader isLoading={isLoading} />
            <Navbar />
            <div className='main-container'>
                <SearchAndFilterBar />
                <h1>Latest Request</h1>
                <LatestRequestsC data={LeastestRequest} onCardClick={handleCardClick} />  

            </div>
        </>

    )
}

export default LatestRequest